import _ from 'lodash';

import { list, vettingParticipation, vettingCommitteeList } from './tags';

function endpoints(builder, tefafApi) {
  return {
    getVetterVettingParticipation: builder.query({
      query: ({ fairId, standNumber }) => `tefaf/vetterportal/participation/get/${fairId || 0}/${standNumber || 0}`,
      providesTags: vettingParticipation,
    }),
    getCommittee: builder.query({
      query: (committeeId) => `tefaf/vetterportal/committee/list/${committeeId}`,
      providesTags: vettingCommitteeList,
    }),
    getVetterArtObjects: builder.query({
      query: ({ fairId, portalType }) => `tefaf/vetterportal/vetting-history/list/${portalType}/${fairId}`,
      providesTags: list,
    }),
    getVetterArtObject: builder.query({
      query: ({ fairId, artObjectId, portalType }) => `tefaf/vetterportal/vetting-history/get/${portalType}/${fairId}/${artObjectId || 0}`,
      providesTags: (result, error, arg) => [{ type: list[0], id: arg.artObjectId }],
      async onQueryStarted({ fairId, artObjectId, portalType }, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedArtObject } = await queryFulfilled;
          dispatch(tefafApi.util.updateQueryData('getVetterArtObjects', { fairId, portalType }, (draft) => {
            if (!artObjectId) {
              return;
            }
            const index = draft.findIndex((artObject) => `${artObject.id}` === `${artObjectId}`);
            if (updatedArtObject.id) {
              if (index === -1) {
                draft.push(updatedArtObject);
              } else {
                draft.splice(index, 1, updatedArtObject);
              }
            } else if (index > -1) {
              draft.splice(index, 1);
            }
          }));
        } catch {
          // continue regardless of error
        }
      },
    }),
    createArtObjectVettingHistory: builder.mutation({
      invalidatesTags: (result) => [{ type: list[0], id: result.artObjectId }],
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', 'tefaf/vetterportal/vetting-history/create-art-object-vetting-history');
        if (values.artObjectId) {
          body.append('artObjectId', values.artObjectId);
        }
        if (values.participationId) {
          body.append('participationId', values.participationId);
        }
        body.append('vettingHistoryStatusId', values.vettingHistoryStatus);
        body.append('fields[artObjectTitle]', values.artObjectTitle);
        body.append('fields[vettingHistoryNote]', values.vettingHistoryNote);
        _.forEach(values.artObjectImages, (file) => {
          body.append('fields[artObjectImages][]', (_.isObject(file) && file.id ? file.id : file));
        });
        _.forEach(values.artObjectLabel, (file) => {
          body.append('fields[artObjectLabel][]', (_.isObject(file) && file.id ? file.id : file));
        });
        _.forEach(values.vettingHistoryDocuments, (file) => {
          body.append('fields[vettingHistoryDocuments][]', (_.isObject(file) && file.id ? file.id : file));
        });

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
    updateArtObjectVettingHistory: builder.mutation({
      invalidatesTags: (result, error, arg) => [{ type: list[0], id: arg.artObjectId }],
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', 'tefaf/vetterportal/vetting-history/update-art-object-vetting-history');
        body.append('artObjectId', values.artObjectId);
        body.append('vettingHistoryStatusId', values.vettingHistoryStatus);
        body.append('fields[vettingHistoryNote]', values.vettingHistoryNote);
        _.forEach(values.vettingHistoryDocuments, (file) => {
          body.append('fields[vettingHistoryDocuments][]', (_.isObject(file) && file.id ? file.id : file));
        });
        body.append('vettingHistoryPreventEmail', !_.isEmpty(values.vettingHistoryPreventEmail));

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
    disableArtObjectVettingHistory: builder.mutation({
      invalidatesTags: (result, error, arg) => [{ type: list[0], id: arg.artObjectId }],
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', 'tefaf/tefafportal/art-object/disable');
        body.append('artObjectId', values.artObjectId);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
    deleteVettingHistory: builder.mutation({
      invalidatesTags: (result, error, arg) => [{ type: list[0], id: arg.artObjectId }],
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', 'tefaf/tefafportal/vetting-history/delete');
        body.append('vettingHistoryId', values.vettingHistoryId);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
  };
}

export { endpoints };
